import React, { useRef } from "react";

import sweetAlert from "sweetalert";
import { useApolloClient } from "@apollo/client";
import { CSSTransition } from "react-transition-group";

import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from "primereact/accordion";

/** context */
import { useUser } from "./context/users";
import { useSettings } from "./context/settings";

/** services */

/** utils */

const AppInlineMenu = (props: any) => {
    const user = useUser();

    const menuRef = useRef(null);

    const [showProfile, setShowProfile] = React.useState(false);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [submitted, setSubmitted] = React.useState<boolean>(false);
    const [showChangePassword, setShowChangePassword] = React.useState(false);

    const [currentPassword, setCurrentPassword] = React.useState("");
    const [newPassword, setNewPassword] = React.useState("");

    function _changePassword() {
        setSubmitted(true);
        console.log("oi");

        if (!currentPassword || !newPassword) return;

        setLoading(true);

        // apollo
        //     .mutate({
        //         mutation: CHANGE_PASSWORD,
        //         variables: {
        //             password: currentPassword,
        //             newPassword: newPassword,
        //         },
        //     })
        //     .then(response => {
        //         sweetAlert({ text: "Successo!", title: "Sua senha foi alterada com sucesso" });
        //         setLoading(false);
        //     })
        //     .catch(error => {
        //         setLoading(false);
        //         settings.setErrorMessage(getGraphsqErros(error));
        //         settings.setVisibleError(true);
        //     });
    }

    const isSlim = () => {
        return props.menuMode === "slim";
    };

    const isStatic = () => {
        return props.menuMode === "static";
    };

    const isSidebar = () => {
        return props.menuMode === "sidebar";
    };

    const isMobile = () => {
        return window.innerWidth <= 991;
    };

    const getName = () => {
        if (user && user?.getUser() && user?.getUser()?.name && user?.getUser()?.name?.length) {
            return user?.getUser()?.name;
        } else {
            return user?.getUser()?.phone;
        }
    };
    return (
        <>
            {!isMobile() && (isStatic() || isSlim() || isSidebar()) && (
                <div className={classNames("layout-inline-menu", { "layout-inline-menu-active": props.activeInlineProfile })}>
                    <button className="layout-inline-menu-action p-link" onClick={props.onChangeActiveInlineMenu}>
                        <img src="assets/layout/images/logo-light.png" alt="avatar" style={{ width: "25px", height: "25px" }} />
                        <span className="layout-inline-menu-text">{getName()}</span>
                        <i className="layout-inline-menu-icon pi pi-angle-down"></i>
                    </button>
                    <CSSTransition
                        nodeRef={menuRef}
                        classNames="p-toggleable-content"
                        timeout={{ enter: 1000, exit: 450 }}
                        in={props.activeInlineProfile}
                        unmountOnExit>
                        <ul ref={menuRef} className="layout-inline-menu-action-panel">
                            <li className="layout-inline-menu-action-item">
                                <button type={"button"} className="p-link" onClick={() => setShowProfile(true)}>
                                    <i className="pi pi-info-circle pi-fw"></i>
                                    <span>Perfil</span>
                                </button>
                            </li>
                            {/* <li className="layout-inline-menu-action-item">
                                <button type={"button"} className="p-link" onClick={() => setShowChangePassword(true)}>
                                    <i className="pi pi-key pi-fw"></i>
                                    <span>Alterar minha senha</span>
                                </button>
                            </li> */}
                            <li className="layout-inline-menu-action-item">
                                <button className="p-link" type={"button"} onClick={() => user?.logout()}>
                                    <i className="pi pi-power-off pi-fw"></i>
                                    <span>Sair</span>
                                </button>
                            </li>
                        </ul>
                    </CSSTransition>

                    {/* Modal alterar senha */}
                    <Dialog
                        header="Alterar senha"
                        visible={showChangePassword}
                        style={{ width: "20vw" }}
                        modal
                        footer={() => (
                            <>
                                <Button
                                    disabled={loading}
                                    type="button"
                                    label="Cancelar"
                                    onClick={() => setShowChangePassword(false)}
                                    icon="pi pi-times-circle"
                                    className="p-button-text text-red-500"
                                />
                                <Button
                                    disabled={loading}
                                    autoFocus
                                    type="button"
                                    label={loading ? "Alterando..." : "Alterar"}
                                    onClick={() => _changePassword()}
                                    icon="pi pi-check"
                                    className="p-button-text"
                                />
                            </>
                        )}
                        onHide={() => (loading ? null : setShowChangePassword(false))}>
                        <div className="form-container">
                            <div className="field text-left flex flex-column  align-items-stretch">
                                <span className="p-input-icon-left">
                                    <i className="pi pi-key"></i>
                                    <InputText
                                        style={{ width: "100%" }}
                                        autoComplete="new-password"
                                        type="password"
                                        placeholder=""
                                        onChange={e => setCurrentPassword(e.target.value)}
                                        value={currentPassword}
                                        className={classNames("pt-3 pb-3 ", { "p-invalid": submitted && !currentPassword })}
                                    />
                                </span>
                                {submitted && !currentPassword && <small className="p-invalid">Informe sua senha atual.</small>}
                            </div>

                            <div className="field text-left flex flex-column  align-items-stretch">
                                <span className="p-input-icon-left">
                                    <i className="pi pi-key"></i>
                                    <InputText
                                        style={{ width: "100%" }}
                                        autoComplete="new-password"
                                        type="password"
                                        placeholder=""
                                        onChange={e => setNewPassword(e.target.value)}
                                        value={newPassword}
                                        className={classNames("pt-3 pb-3 ", { "p-invalid": submitted && !newPassword })}
                                    />
                                </span>
                                {submitted && !newPassword && <small className="p-invalid">Informe sua nova senha.</small>}
                            </div>
                        </div>
                    </Dialog>

                    {/* Modal informações do perfil */}
                    <Dialog
                        header="Meus dados"
                        visible={showProfile}
                        style={{ width: "20vw" }}
                        modal
                        footer={() => (
                            <>
                                <Button
                                    autoFocus
                                    type="button"
                                    label={"OK"}
                                    onClick={() => setShowProfile(false)}
                                    icon="pi pi-check"
                                    className="p-button-text"
                                />
                            </>
                        )}
                        onHide={() => setShowProfile(false)}>
                        <div className="form-container">
                            <Accordion activeIndex={0}>
                                <AccordionTab header="Cadastro" tabIndex={0}>
                                    <p>UID: {user?.getUser()?.uid}</p>
                                    <p>Nome: {user?.getUser()?.name}</p>
                                    <p>Telefone: {user?.getUser()?.phone}</p>
                                    <p>ID: {user?.getUser()?.id}</p>
                                </AccordionTab>
                                {/* <AccordionTab header="Secretaria" tabIndex={1}>
                                    <p>
                                        {user?.getUser()?.descricaoSecretaria} de {user?.getUser()?.municipio}
                                    </p>
                                </AccordionTab>
                                <AccordionTab header="Setor" tabIndex={2}>
                                    <p>{user?.getUser()?.descricaoSetor}</p>
                                </AccordionTab>

                                <AccordionTab header="Cargo" tabIndex={3}>
                                    <p>{user?.getUser()?.descricaoCargo}</p>
                                </AccordionTab> */}
                            </Accordion>
                        </div>
                    </Dialog>
                </div>
            )}
        </>
    );
};

export default AppInlineMenu;
